import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import {  Typography } from "@mui/material";

const LoadingComponent = ({message}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        zIndex: 1300, // To ensure it overlays other components
      }}
    >
      <CircularProgress />
      <Typography sx={{ marginTop: 2 }}>{message}</Typography>
    </Box>
  );
};

export default LoadingComponent;